import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/lastfm-square': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M400 32c26.5 0 48 21.5 48 48v352c0 26.5-21.5 48-48 48h-352c-26.5 0-48-21.5-48-48v-352c0-26.5 21.5-48 48-48h352zM307.8 344.9c45.4 0 76.2-13.9 76.1-50.6 0-45.5-39.1-50.4-71.8-57.5-16.1-3.7-20.9-10.3-20.9-21.3 0-12.5 9.9-19.8 26-19.8 17.6 0 27.1 6.6 28.6 22.4l36.7-4.4c-2.9-33-25.6-46.6-63-46.6-32.9 0-65.2 12.4-65.2 52.4 0 24.9 12.1 40.7 42.5 48 28.1 6.6 49.9 8.7 49.9 28.6 0 13.6-13.2 19.1-38.1 19.1-37 0-52.4-19.4-61.2-46.2-20-60.5-27.3-101.9-100.8-101.9-53.9 0-82.5 34.1-82.5 92 0 55.7 28.6 85.8 79.9 85.8 41.4 0 61.2-19.4 61.2-19.4l-11.7-31.9s-19 21.3-47.6 21.3c-25.3 0-43.3-22-43.3-57.2 0-45.1 22.7-61.2 45.1-61.2 41.5 0 46.7 33.3 63 84.3 11.7 35.5 33.7 64.1 97.1 64.1z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/lastfm-square.js
// module id = 913
// module chunks = 0